import type { FunctionComponent } from 'react';
import { Suspense } from 'react';
import { Outlet } from 'react-router';
import { Footer } from 'src/layouts/footer/Footer';
import { Header } from 'src/layouts/header/Header';
import style from './Main.module.scss';

export const Main: FunctionComponent = () => (
  <div className={style.page}>
    <Header />
    <main className={style.main}>
      <Suspense fallback={null}>
        <Outlet />
      </Suspense>
    </main>
    <Footer />
  </div>
);
